import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        routerStr:'',
        remRatio:0,
        updateRemRatio:0,

        countryId:null,
        provinceId:null,
        cityId:null,
        hotelId:null,
        hotelType:'0',
        headerIdStr:null,
        headerUpdate:0,
        headerLogo:'',
        sideBarShow:false,
        userData:{
            version:'0',
            username:'',
            Id:'',
            role:'',
            lastLoginTime:'2018-12-22 13:30:21',
            client_key:'',
            token:'',
            number:'',
            avatar:'',
        },
        editHotelLogoShow:false,
        editHotelLogoShowBg:false,
        longitude:0,
        latitude:0,

        domainName:'iotena',

        isGoogleapis:false,
        webapiAmap:false,
    },
    getters: {
        domainName:state=>state.domainName,
        routerStr:state=>state.routerStr,
        remRatio:state=>state.remRatio,

        headerLogo:state=>state.headerLogo,
        sideBarShow:state=>state.sideBarShow,

        editHotelLogoShow:state=>state.editHotelLogoShow,
        editHotelLogoShowBg:state=>state.editHotelLogoShowBg,

        countryId:state=>state.countryId,
        provinceId:state=>state.provinceId,
        cityId:state=>state.cityId,
        hotelId:state=>state.hotelId,
        hotelType:state=>state.hotelType,
        longitude:state=>state.longitude,
        latitude:state=>state.latitude,

        headerIdStr:state=>state.headerIdStr,
        headerUpdate:state=>state.headerUpdate,
        updateRemRatio:state=>state.updateRemRatio,

        version:state=>state.userData.version,
        username:state=>state.userData.username,
        id:state=>state.userData.id,
        role:state=>state.userData.role,
        lastLoginTime:state=>state.userData.lastLoginTime,
        client_key:state=>state.userData.client_key,
        token:state=>state.userData.token,
        number:state=>state.userData.number,
        avatar:state=>state.userData.avatar,

        isGoogleapis:state=>state.isGoogleapis,
        webapiAmap:state=>state.webapiAmap,
    },
    actions: {

    },
    mutations: {
        DOMAINNAME(state,payload){
            state.domainName = payload.domainName;
        },
        ISGOOGLEAPIS(state,payload){
            state.isGoogleapis = payload.isGoogleapis;
        },
        WEBAPIAMAP(state,payload){
            state.webapiAmap = payload.webapiAmap;
        },
        
        HEADERLOGO(state,payload){
            state.headerLogo = payload.headerLogo;
        },
        EDITHOTELLOGOSHOW(state,payload){
            if(payload.editHotelLogoShow){
                state.editHotelLogoShow = payload.editHotelLogoShow;
            }
            if(payload.editHotelLogoShowBg){
                state.editHotelLogoShowBg = payload.editHotelLogoShowBg;
            }
        },
        SIDEBARSHOW(state,payload){
            state.sideBarShow = payload.sideBarShow;
        },
        USERDATAFUN:(state,payload)=>{
            state.userData.version = payload.version;
            state.userData.username = payload.username;
            state.userData.id = payload.id;
            state.userData.role = payload.role;
            state.userData.lastLoginTime = payload.lastLoginTime;
            state.userData.client_key = payload.client_key;
            state.userData.token = payload.token;
            state.userData.number = payload.number;
            state.userData.avatar = payload.avatar;
        },
        VERSION:(state,payload)=>{
            state.userData.version = payload.version;
        },
        HEADERIDFUN:(state,payload)=>{
            if(payload.countryId||payload.countryId == ''){
                state.countryId = payload.countryId;    
            }
            if(payload.provinceId||payload.provinceId == ''){
                state.provinceId = payload.provinceId;    
            }
            if(payload.cityId||payload.cityId == ''){
                state.cityId = payload.cityId;    
            }
            if(payload.hotelId||payload.hotelId == ''){
                state.hotelId = payload.hotelId;    
            }
            if(payload.hotelType||payload.hotelType == ''){
                state.hotelType = payload.hotelType;    
            }
            if(payload.headerIdStr||payload.headerIdStr == ''){
                state.headerIdStr = payload.headerIdStr;    
            }
            if(payload.headerUpdate){
                state.headerUpdate = payload.headerUpdate;    
            }
        },

        LONLATFUN:(state,payload)=>{
            state.longitude = payload.longitude;    
            state.latitude = payload.latitude;    
        },
        UPDATEREMRATIOFUN:(state,payload)=>{
            state.updateRemRatio = payload.updateRemRatio;
        },

        ROUTERSTRFUN:(state,payload)=>{
            state.routerStr = payload.routerStr;
        },

        REMRATIOFUN:(state,payload)=>{
            state.remRatio = payload.remRatio;
        },
    },
})
